import { Citrus } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const LANGS = ['en', 'es', 'fr', 'de', 'nl'];

export const AnnouncementBar = () => {
  const { t } = useLanguage();
  const items = [...t.announcement, ...t.announcement, ...t.announcement];
  return (
    <div className="bg-brand-orange text-brand-cream py-2 overflow-hidden" data-testid="announcement-bar">
      <div className="animate-marquee whitespace-nowrap flex gap-10 w-max text-[11px] font-bold uppercase tracking-[0.15em]">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span>{item}</span>
            <span className="opacity-60">●</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export const Header = () => {
  const { t, lang, setLang } = useLanguage();
  const navItems = [
    { href: '#product', label: t.nav.bottle },
    { href: '#how-it-works', label: t.nav.how },
    { href: '#surfaces', label: t.nav.surfaces },
    { href: '#reviews', label: t.nav.reviews },
    { href: '#faq', label: t.nav.faq },
    { href: '#office', label: t.nav.office },
  ];
  return (
    <header className="sticky top-0 z-50 bg-brand-cream/80 backdrop-blur-xl border-b border-brand-green/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <div className="flex items-center gap-5">
          <a href="#hero" data-testid="brand-logo-link" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-full bg-brand-orange flex items-center justify-center text-white shadow-inner -rotate-6">
              <Citrus className="w-5 h-5" />
            </div>
            <span className="font-display text-2xl uppercase tracking-tight text-brand-green">Angry Tangerine</span>
          </a>
          <span className="hidden xl:inline-flex text-[10px] font-bold uppercase tracking-[0.18em] px-2.5 py-1 rounded-full bg-brand-green/10 text-brand-green">{t.header.tag}</span>
        </div>

        <nav className="hidden lg:flex items-center gap-7 text-sm font-bold tracking-wide text-brand-green/75">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className="hover:text-brand-orange transition-colors">{item.label}</a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div data-testid="language-switcher" className="flex items-center bg-white/70 border border-brand-green/15 rounded-full p-1 text-[11px] font-bold text-brand-green">
            {LANGS.map((l) => (
              <button
                key={l}
                type="button"
                data-testid={`lang-${l}-btn`}
                onClick={() => setLang(l)}
                className={`px-2 py-1 rounded-full transition-colors ${lang === l ? 'bg-brand-green text-white' : 'hover:text-brand-orange'}`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          <a
            href="#product"
            data-testid="header-buy-btn"
            className="hidden sm:inline-flex items-center justify-center px-5 py-2.5 rounded-full bg-brand-orange text-white text-xs font-extrabold uppercase tracking-wider hover:bg-[#C75007] hover:scale-[0.98] transition-all shadow-md"
          >
            {t.header.buy}
          </a>
        </div>
      </div>
    </header>
  );
};
